import { LineChartTooltipView } from 'backbone/shared/views/chartist/line_chart_tooltip_view.js'
import Chartist from 'chartist/dist/chartist.js'
import MetricFormatter from 'utils/platform/metric_formatter.js'

export class LineChartView extends Backbone.View
  initialize: (options) ->
    # the data is being reversed so that the newer line shows up on top
    # css is also heavy in action to do this
    @data =
      series: options.data.series_with_meta.reverse()
      labels: options.data.labels

    @integerOnly = options.integerOnly
    @format = options.format

    chartWrapperSelector = "##{@$el.attr('id')} .chart-wrapper"
    chart = new Chartist.Line(
      chartWrapperSelector,
      @data,
      @chartOptions(),
      @responsiveOptions()
    )

    @tooltipView = new LineChartTooltipView(el: chartWrapperSelector)

    if @data.series.length is 2
      @$el.find(".chart-wrapper").addClass("ct-chart-reverse-colors")

    chart.on 'draw', (data) =>
      if data.type is "point"
        @onPointDraw(data)

      if data.type == "label"
        @onLabelDraw(data)

  onPointDraw: (data) =>
    radius = 4.5

    if data.series.length > 10
      @$el.find(".chart-wrapper").addClass("ct-chart-no-circles")

    # if the chart only has one line
    if @data.series.length is 1
      if data.series.length > 10
        radius = 1.5

    # if the chart has comparison lines
    if @data.series.length is 2
      if data.seriesIndex is 0
        # prior line data
        radius = 3
      if data.seriesIndex is 1 and data.series.length > 10
        # current line data
        radius = 1.5

    circle = new Chartist.Svg('circle', {
      cx: data.x,
      cy: data.y,
      r: radius,
      "ct:meta": data.meta,
      "ct:value": data.value
    }, 'ct-circle')

    data.element.replace(circle)

  onLabelDraw: (data) ->
    # Don't translate axes
    data.element._node.setAttribute('notranslate', true)

  chartOptions: ->
    height: 243
    lineSmooth: Chartist.Interpolation.simple(divisor: 2)
    fullWidth: (true unless @data.labels.length == 1)
    chartPadding:
      right: 40
    low: 0
    axisX:
      labelInterpolationFnc: (value, index) =>
        interval = Math.ceil(@data.labels.length/8)
        if index % interval == 0 then value else null
    axisY:
      onlyInteger: @integerOnly
      offset: 50
      labelInterpolationFnc: (value, index) =>
        MetricFormatter.format(value, @format, @decimalPlaces(), "axis")

  decimalPlaces: =>
    greatestValue = _.max @data.series[0], (item) ->
      item.value
    if greatestValue.value > 1000
      0
    else
      2

  responsiveOptions: ->
    [
      [
        'screen and (max-width: 640px)'
        {
          showPoint: false
          axisX:
            labelInterpolationFnc: (value, index) =>
              interval = Math.ceil(@data.labels.length/4)
              if index % interval == 0 then value else null
        }
      ]
    ]



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/chartist/line_chart_view.js.coffee